import { render, staticRenderFns } from "./AnnualActivitySummary.vue?vue&type=template&id=63c51c5a&scoped=true&"
import script from "./AnnualActivitySummary.vue?vue&type=script&lang=js&"
export * from "./AnnualActivitySummary.vue?vue&type=script&lang=js&"
import style0 from "./AnnualActivitySummary.vue?vue&type=style&index=0&id=63c51c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c51c5a",
  null
  
)

export default component.exports